import React, { useEffect, useState } from 'react';
import logo from '../../assets/icons/odo-logo-res.png';

const WelcomeSlide: React.FC = () => {
    const [stage, setStage] = useState(0);

    useEffect(() => {
        const t1 = setTimeout(() => setStage(1), 100);
        const t2 = setTimeout(() => setStage(2), 600);
        const t3 = setTimeout(() => setStage(3), 1100);
        return () => {
            clearTimeout(t1);
            clearTimeout(t2);
            clearTimeout(t3);
        };
    }, []);

    return (
        <div className="flex flex-col items-center justify-center gap-8 w-full h-full">
            {/* Logo */}
            <div
                className="transition-all duration-[800ms] ease-out"
                style={{
                    opacity: stage >= 1 ? 1 : 0,
                    transform: stage >= 1 ? 'translateY(0) scale(1)' : 'translateY(20px) scale(0.9)'
                }}
            >
                <img src={logo} alt="Odo" className="h-24 w-auto" />
            </div>

            {/* Title */}
            <h1
                className="text-5xl font-bold text-gray-900 tracking-tight text-center transition-all duration-[800ms] ease-out"
                style={{
                    opacity: stage >= 2 ? 1 : 0,
                    transform: stage >= 2 ? 'translateY(0)' : 'translateY(24px)'
                }}
            >
                Welcome to your new dashboard
            </h1>

            {/* Subtitle */}
            <p
                className="text-lg text-gray-400 text-center max-w-md leading-relaxed transition-all duration-[800ms] ease-out"
                style={{
                    opacity: stage >= 3 ? 1 : 0,
                    transform: stage >= 3 ? 'translateY(0)' : 'translateY(20px)'
                }}
            >
                Let us show you around.
            </p>
        </div>
    );
};

export default WelcomeSlide;
